/* eslint-disable import/prefer-default-export */
const ENV_SENTRY_DSN =
  process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

export const SENTRY_DSN =
  process.env.NODE_ENV !== "production"
    ? null
    : ENV_SENTRY_DSN ||
      "https://d615b34285c643f7a8efd5fd9075ec67@o1002887.ingest.sentry.io/5996025";
